<!-- main-header -->
<div class="main-header side-header stickyy sticky nav nav-item">
  <div class="container-fluid main-container ">
    <div class="main-header-left ">
      <div class="responsive-logo">
        <a class="header-logo">
          <img src="./assets/img/brand/logos.png" class="logo-1" alt="logo">
          <img src="./assets/img/brand/sistemasblanco.png" class="dark-logo-1" alt="logo">
        </a>
      </div>
      @if (!isMobile) {
        <div class="app-sidebar__toggle" data-bs-toggle="sidebar">
          <a class="open-toggle" href="javascript:void(0);" (click)="toggleSidebarOpen()"><i
          class="header-icon fe fe-align-left"></i></a>
          <a class="close-toggle" href="javascript:void(0);" (click)="toggleSidebarClose()"><i
          class="header-icons fe fe-x"></i></a>
        </div>
      }

    </div>
    <div class="main-header-right">
      @if (!isMobile) {
        <button class="navbar-toggler navresponsive-toggler  ms-auto" type="button" (click)="collapse.toggle()"
          [attr.aria-expanded]="!isCollapsed">
          <span class="navbar-toggler-icon fe fe-more-vertical "></span>
        </button>
      }
      <div class="mb-0 navbar navbar-expand-lg navbar-nav-right responsive-navbar navbar-dark p-0">
        <div class="collapse navbar-collapse" id="navbarSupportedContent-4" #collapse="ngbCollapse"
          [(ngbCollapse)]="isCollapsed">
          <ul class="nav nav-item d-lg-none d-flex navbar-nav-right ms-auto">
            <li class="dropdown nav-item main-layout">
              <a class="new nav-link theme-layout nav-link-bg layout-setting" appToggleTheme>
                <span class="dark-layout"><svg xmlns="http://www.w3.org/2000/svg"
                  class="header-icon-svgs" width="24" height="24" viewBox="0 0 24 24">
                  <path
                    d="M20.742 13.045a8.088 8.088 0 0 1-2.077.271c-2.135 0-4.14-.83-5.646-2.336a8.025 8.025 0 0 1-2.064-7.723A1 1 0 0 0 9.73 2.034a10.014 10.014 0 0 0-4.489 2.582c-3.898 3.898-3.898 10.243 0 14.143a9.937 9.937 0 0 0 7.072 2.93 9.93 9.93 0 0 0 7.07-2.929 10.007 10.007 0 0 0 2.583-4.491 1.001 1.001 0 0 0-1.224-1.224zm-2.772 4.301a7.947 7.947 0 0 1-5.656 2.343 7.953 7.953 0 0 1-5.658-2.344c-3.118-3.119-3.118-8.195 0-11.314a7.923 7.923 0 0 1 2.06-1.483 10.027 10.027 0 0 0 2.89 7.848 9.972 9.972 0 0 0 7.848 2.891 8.036 8.036 0 0 1-1.484 2.059z" />
                </svg></span>
                <span class="light-layout"><svg xmlns="http://www.w3.org/2000/svg"
                  class="header-icon-svgs" width="24" height="24" viewBox="0 0 24 24">
                  <path
                    d="M6.993 12c0 2.761 2.246 5.007 5.007 5.007s5.007-2.246 5.007-5.007S14.761 6.993 12 6.993 6.993 9.239 6.993 12zM12 8.993c1.658 0 3.007 1.349 3.007 3.007S13.658 15.007 12 15.007 8.993 13.658 8.993 12 10.342 8.993 12 8.993zM10.998 19h2v3h-2zm0-17h2v3h-2zm-9 9h3v2h-3zm17 0h3v2h-3zM4.219 18.363l2.12-2.122 1.415 1.414-2.12 2.122zM16.24 6.344l2.122-2.122 1.414 1.414-2.122 2.122zM6.342 7.759 4.22 5.637l1.415-1.414 2.12 2.122zm13.434 10.605-1.414 1.414-2.122-2.122 1.414-1.414z" />
                </svg></span>
              </a>
            </li>

            <li class="nav-item full-screen fullscreen-button">
              <a class="new nav-link full-screen-link" href="javascript:;" appFullscreen>
                <i class="fe fe-maximize"></i>
              </a>
            </li>

            <li class="nav-item full-screen fullscreen-button">
              <a class="new nav-link full-screen-link" href="javascript:;" appFullscreen>
                <i class="fe fe-maximize"></i>
              </a>
            </li>
            <div ngbDropdown class="dropdown main-profile-menu nav nav-item nav-link">
              <a class="profile-user d-flex" href="javascript:;" ngbDropdownToggle><img alt=""
              src="{{foto}}"></a>
              <div ngbDropdownMenu>
                <div class="main-header-profile bg-primary p-3">
                  <div class="d-flex wd-100p">
                    <div class="main-img-user"><img alt="" src="{{foto}}" class="">
                    </div>
                    <div class="ms-3 my-auto">
                      <h6>{{nombre}}</h6><span>{{perfil}}</span>
                    </div>
                  </div>
                </div>
                <a class="dropdown-item" routerLink="/sistema/mi-perfil">
                  <i class="bx bx-user"></i> Mi perfil
                </a>
                <a class="dropdown-item" (click)="logout()"><i class="bx bx-log-out"></i>
              Salir</a>
            </div>
          </div>

        </ul>
      </div>
    </div>
    <div class="mb-0 navbar navbar-expand-lg navbar-nav-right responsive-navbar navbar-dark p-0">
      <div class="collapse navbar-collapse" id="navbarSupportedContent-4">
        <ul class="nav nav-item  navbar-nav-right ms-auto">
          <li class="nav-item full-screen fullscreen-button">
            <a class="new nav-link full-screen-link" href="javascript:;"  href="https://sistema.cmsalud.ec/radiografia" target="_blank">
              <i class="fa fa-notes-medical"></i>
            </a>
          </li>
          <li class="nav-item full-screen fullscreen-button">
            <a class="new nav-link full-screen-link" href="javascript:;" (click)="verInformacion(mdlInformacion)">
              <i class="fas fa-exclamation-circle text-primary"></i>
            </a>
          </li>
          @if (canVerMenuReportes) {
          <div ngbDropdown class="nav-item main-header-message ">
            <a class="new nav-link" href="javascript:;" ngbDropdownToggle>
              <i class="zmdi zmdi-collection-pdf text-danger"></i>

            </a>
            <div ngbDropdownMenu>
              <div class="menu-header-content bg-primary text-left">
                <div class="d-flex">
                  <h6 class="dropdown-title mb-1 tx-15 text-white font-weight-semibold">REPORTES
                  </h6>

                </div>

              </div>
              <div class="main-message-list chat-scroll">
                @if (canVerReporteVentas) {
                <a  class="p-3 d-flex border-bottom" (click)="generarReporte()">
                  <div class="  drop-img  cover-image  "
                    style="background: url(./assets/img/flags/pdf-icon.png);">

                  </div>
                  <div class="wd-90p">
                    <div class="d-flex">
                      <h5 class="mb-1 name">Ventas</h5>
                    </div>
                    <p class="mb-0 desc">En esta opción podrás visualizar el reporte de ventas, presione para visualizar.</p>

                  </div>
                </a>
                }
                @if (canVerEnvioReporte) {
                <a  class="p-3 d-flex border-bottom" (click)="enviarReporte()">
                  <div class="drop-img cover-image"
                    style="background: url(./assets/img/flags/whatsapp.png);">

                  </div>
                  <div class="wd-90p">
                    <div class="d-flex">
                      <h5 class="mb-1 name">Envío Reporte</h5>
                    </div>
                    <p class="mb-0 desc">En esta opción podrá enviar su reporte a administración, presione para enviar.</p>

                  </div>
                </a>
                }
                <a routerLink="/pages/chat" class="p-3 d-flex border-bottom">

                  <div class="wd-90p">

                  </div>
                </a>


              </div>
              <div class="text-center dropdown-footer">

              </div>
            </div>
          </div>
          }
          <li class="dropdown nav-item main-layout">
            <a class="new nav-link theme-layout nav-link-bg layout-setting" appToggleTheme>
              <span class="dark-layout"><svg xmlns="http://www.w3.org/2000/svg"
                class="header-icon-svgs" width="24" height="24" viewBox="0 0 24 24">
                <path
                  d="M20.742 13.045a8.088 8.088 0 0 1-2.077.271c-2.135 0-4.14-.83-5.646-2.336a8.025 8.025 0 0 1-2.064-7.723A1 1 0 0 0 9.73 2.034a10.014 10.014 0 0 0-4.489 2.582c-3.898 3.898-3.898 10.243 0 14.143a9.937 9.937 0 0 0 7.072 2.93 9.93 9.93 0 0 0 7.07-2.929 10.007 10.007 0 0 0 2.583-4.491 1.001 1.001 0 0 0-1.224-1.224zm-2.772 4.301a7.947 7.947 0 0 1-5.656 2.343 7.953 7.953 0 0 1-5.658-2.344c-3.118-3.119-3.118-8.195 0-11.314a7.923 7.923 0 0 1 2.06-1.483 10.027 10.027 0 0 0 2.89 7.848 9.972 9.972 0 0 0 7.848 2.891 8.036 8.036 0 0 1-1.484 2.059z" />
              </svg></span>
              <span class="light-layout"><svg xmlns="http://www.w3.org/2000/svg"
                class="header-icon-svgs" width="24" height="24" viewBox="0 0 24 24">
                <path
                  d="M6.993 12c0 2.761 2.246 5.007 5.007 5.007s5.007-2.246 5.007-5.007S14.761 6.993 12 6.993 6.993 9.239 6.993 12zM12 8.993c1.658 0 3.007 1.349 3.007 3.007S13.658 15.007 12 15.007 8.993 13.658 8.993 12 10.342 8.993 12 8.993zM10.998 19h2v3h-2zm0-17h2v3h-2zm-9 9h3v2h-3zm17 0h3v2h-3zM4.219 18.363l2.12-2.122 1.415 1.414-2.12 2.122zM16.24 6.344l2.122-2.122 1.414 1.414-2.122 2.122zM6.342 7.759 4.22 5.637l1.415-1.414 2.12 2.122zm13.434 10.605-1.414 1.414-2.122-2.122 1.414-1.414z" />
              </svg></span>
            </a>
          </li>



          <li class="nav-item full-screen fullscreen-button">
            <a class="new nav-link full-screen-link" href="javascript:;" appFullscreen>
              <i class="fe fe-maximize"></i>
            </a>
          </li>
          <div ngbDropdown class="main-profile-menu nav nav-item nav-link">
            <a class="profile-user d-flex" href="javascript:;" ngbDropdownToggle><img alt=""
            src="{{foto}}"></a>
            <div ngbDropdownMenu>
              <div class="main-header-profile bg-primary p-3">
                <div class="d-flex wd-100p">
                  <div class="main-img-user"><img alt="" src="{{foto}}" class="">
                  </div>
                  <div class="ms-3 my-auto">
                    <h6>{{nombre}}</h6><span>{{perfil}}</span>
                  </div>
                </div>
              </div>
              <a class="dropdown-item" routerLink="/sistema/mi-perfil">
                <i class="bx bx-user"></i> Mi perfil
              </a>
              <a class="dropdown-item"  (click)="logout()"><i class="bx bx-log-out"></i>
            Salir</a>
          </div>
        </div>

      </ul>
    </div>
  </div>

</div>
</div>
</div>

@if (isMobile) {
  <nav class="mobile-global-topbar">
    @for (item of mobilePrimaryItems; track item) {
      <a
        class="mobile-global-link"
        [class.active]="esMenuMovilActivo(item)"
        [routerLink]="item.path">
        <i [class]="item.icon"></i>
        <span>{{ item.title }}</span>
      </a>
    }
    @if (mostrarMasMovil) {
      <div ngbDropdown placement="top-end" class="mobile-global-more">
        <button class="mobile-global-link more-btn" ngbDropdownToggle type="button">
          <i class="fe fe-more-horizontal"></i>
          <span>Más</span>
        </button>
        <div ngbDropdownMenu class="mobile-global-dropdown">
          @for (group of mobileMoreGroups; track group; let i = $index) {
            @if (i > 0) {
              <div class="dropdown-divider"></div>
            }
            <h6 class="mobile-dd-title">{{ group.title }}</h6>
            @for (option of group.items; track option) {
              <a
                ngbDropdownItem
                [routerLink]="option.path">
                {{ option.title }}
              </a>
            }
          }
          <div class="dropdown-divider"></div>
          <a ngbDropdownItem routerLink="/sistema/mi-perfil">Mi perfil</a>
        </div>
      </div>
    }
    <button
      type="button"
      class="mobile-global-link mobile-global-logout"
      aria-label="Cerrar sesión"
      title="Cerrar sesión"
      (click)="logout()">
      <i class="bx bx-log-out"></i>
      <span>Salir</span>
    </button>
  </nav>
}
<!-- ----------------------------------------------------------------------- -->
<!--                        INGRESAR SECUENCIA FISICA                        -->
<!-- ----------------------------------------------------------------------- -->
<ng-template #mdlInformacion let-modal>

  <div class="modal-body"  >


    <img src="./assets/img/flags/info.png">




  </div>
  <div class="modal-footer">

    <button type="button" class="btn ripple btn-secondary"  (click)="modal.dismiss('Cross click')">Cerrar</button>
  </div>
</ng-template>
